import React from "react"
import BsModal from "react-bootstrap-modal"

const Modal = props => {
  const { className, show, onHide, title, children, backdrop } = props
  return (
    <BsModal backdrop={backdrop} container={document.body} className={className} show={show} onHide={onHide} >
      {title && <BsModal.Header closeButton><BsModal.Title>{title}</BsModal.Title></BsModal.Header>}
      <BsModal.Body>
        {children}
      </BsModal.Body>
    </BsModal>
  )
}

export default Modal
